import { IconProps } from ".";
import { Colors } from "../../styles/colors";

const RefreshIcon = ({ ...props }: IconProps): JSX.Element => {
    const strokeColor = props.color ?? Colors.primaryBlue;
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_471_11691)">
                <path
                    d="M13.4883 35.25L20.2383 30.75L14.2383 25.5"
                    stroke={strokeColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M32.25 16.5C32.25 13.6816 31.4143 10.9265 29.8484 8.58313C28.2826 6.23973 26.0571 4.41327 23.4532 3.33472C20.8494 2.25617 17.9842 1.97398 15.22 2.52382C12.4557 3.07365 9.91663 4.43084 7.92373 6.42373C5.93083 8.41663 4.57365 10.9557 4.02382 13.72C3.47398 16.4842 3.75617 19.3494 4.83472 21.9532C5.91327 24.5571 7.73973 26.7826 10.0831 28.3484C12.4265 29.9142 15.1816 30.75 18 30.75L20.241 30.75"
                    stroke={strokeColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_471_11691">
                    <rect width="36" height="36" fill="white" transform="translate(0 36) rotate(-90)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default RefreshIcon;
